module.exports = __webpack_public_path__ + "images/pages/sns_campaign_lp/balloon-effect-yellow_6ebcf8b970c57f8b2405070f320edf53.png";